import { render } from "./Label.vue?vue&type=template&id=47a6984f&ts=true"
import script from "./Label.ts?vue&type=script&lang=ts&external"
export * from "./Label.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__